import ValidationText from "src/constants/validationText";
import * as yup from "yup";

declare module "yup" {
  interface StringSchema {
    nameValidation(): StringSchema;
  }
}

type NameValidationOpts = {
  required?: boolean;
  requiredMessage?: string;
};

declare module "yup" {
  interface StringSchema {
    nameValidation(opts?: NameValidationOpts): yup.StringSchema;
  }
}

yup.addMethod<yup.StringSchema>(
  yup.string,
  "nameValidation",
  function (opts: NameValidationOpts = {}) {
    const { required = true, requiredMessage } = opts;

    let schema = this.trim()
      .min(3, ValidationText.minLength3)
      .max(75, ValidationText.maxLength75);

    if (required) {
      schema = schema.required(requiredMessage ?? ValidationText.required);
    }

    return schema;
  }
);
